import React, { useContext } from 'react';
import iniciarPed from '../../assets/iniciarPedido.svg';
import Modal from '../../../Modal/Modal';
import { Clientes } from '../clientes';
import useModal from '../../../../Hooks/useModal';
import { useShopingCart } from '../../../ShoppingCart/hooks/useShopingCart';
import closesvg from '../../../Modal/assets/close.svg';
import { useClient } from '../../hooks/useClient';
import { usePermissions } from '../../../../Hooks/usePermissions';
import { SHOPPING_CART } from '../../../../helpers/features';

import './BtnIniciarPedido.css';
import { UserContext } from '../../../auth/context/UserContext';
import { useCliente } from '../../hooks/useCliente';

export const BtnIniciarPedido = () => {
  const { clearItems } = useShopingCart();
  const { data: dataClient, clearClient, setClient } = useClient();
  const { getClientById } = useCliente();

  const { active, toggle } = useModal();
  const { enableFeature } = usePermissions();

  const { dataUser } = useContext(UserContext);

  const eliminarCliente = () => {
    clearClient();
    clearItems();
  };

  const cerrarModal = async () => {
    if (!enableFeature(SHOPPING_CART)) return;

    if (dataClient) return;

    if (dataUser?.clienteId) {
      const cliente = await getClientById(dataUser.clienteId);
      if (cliente) {
        setClient(cliente);
        return;
      }
    }
    toggle(!active);
  };

  return (
    <>
      <div className="contenedorIniciarCompra">
        {dataClient ? (
          <div className="clienteContainer">
            <button className="btnEliminarCliente" onClick={eliminarCliente}>
              <img src={closesvg} alt="close clients" />
            </button>
            <p className="textoAzul"> {dataClient.denominacion} </p>
          </div>
        ) : (
          <button className="btnIniciarCompra" onClick={cerrarModal}>
            <img src={iniciarPed} alt="Iniciar Pedido" />
            <span>Iniciar</span>
          </button>
        )}
        {active && (
          <Modal titulo={'Clientes'} cerrarModal={cerrarModal}>
            <Clientes cerrarModal={cerrarModal} />
          </Modal>
        )}
      </div>
    </>
  );
};
